import serialize from 'serialize-javascript';

export const ContextBuilder = {
  server({ expConfiguration = {}, requestData = {}, hosts = {} }) {
    const experienceContext = {
      channel: requestData.channel || 'desktop',
      cookie: {
        adobeCookie: requestData.adobeCookie
      },
      configService: {
        searchStream: expConfiguration?.['search.stream'],
        searchStreamLimit: expConfiguration?.['search.streamLimit']
      },
      hosts,
      path: (requestData.route && requestData.route.path) || '/',
      store: {
        storeId: requestData.storeId || '121',
        storeName: requestData.storeName || 'Cumberland',
        storeZip: requestData.localStoreZip || '30339'
      },
      segment: requestData.segment,
      isDebugMode: requestData.isDebugMode,
      customer: requestData.customer
    };
    return {
      contextScript: `
      <script>window.__EXPERIENCE_CONTEXT__ =
      {
        "cookie": ${serialize(experienceContext.cookie)},
        "channel": ${serialize(experienceContext.channel)},
        "configService": ${serialize(experienceContext.configService)},
        "hosts": ${serialize(experienceContext.hosts)},
        "path": ${serialize(experienceContext.path)},
        "store": ${serialize(experienceContext.store)},
        "segment": ${serialize(experienceContext.segment)},
        "isDebugMode": ${serialize(experienceContext.isDebugMode)},
        "customer": ${serialize(experienceContext.customer)}
      }
      </script>
      `,
      experienceContext
    };
  },
  client() {
    const experienceContext = {
      cookie: (window.__EXPERIENCE_CONTEXT__ && window.__EXPERIENCE_CONTEXT__.cookie) || {},
      channel: window.__EXPERIENCE_CONTEXT__ && window.__EXPERIENCE_CONTEXT__.channel,
      configService: (window.__EXPERIENCE_CONTEXT__ && window.__EXPERIENCE_CONTEXT__.configService) || {},
      hosts: (window.__EXPERIENCE_CONTEXT__ && window.__EXPERIENCE_CONTEXT__.hosts) || {},
      path: window.__EXPERIENCE_CONTEXT__ && window.__EXPERIENCE_CONTEXT__.path,
      store: (window.__EXPERIENCE_CONTEXT__ && window.__EXPERIENCE_CONTEXT__.store) || {},
      segment: (window.__EXPERIENCE_CONTEXT__ && window.__EXPERIENCE_CONTEXT__.segment) || '',
      isDebugMode: (window.__EXPERIENCE_CONTEXT__ && typeof window.__EXPERIENCE_CONTEXT__.isDebugMode !== 'undefined')
        ? window.__EXPERIENCE_CONTEXT__.isDebugMode
        : false,
      customer: (window.__EXPERIENCE_CONTEXT__ && window.__EXPERIENCE_CONTEXT__.customer) || {}
    };
    return {
      experienceContext
    };
  },
};
